// extracted by mini-css-extract-plugin
module.exports = {"detail":"styles_detail__2PfIU","time":"styles_time__3hkoh"};